import React from 'react';
import PropTypes from 'prop-types';

const EditScreenField = ({ label = '', children }) => {
  return (
    <div className="my-4 w-full">
      <div className="flex flex-col sm:flex-row">
        <div className="w-1/2">
          <div className="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2 mb-2 sm:mb-0">
            {label}
          </div>
        </div>
        <div className="w-full md:w-1/2">{children}</div>
      </div>
    </div>
  );
};

EditScreenField.propTypes = {
  label: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.object
  ]).isRequired
};

export default EditScreenField;
